<template>
    <div class="manage-content">
        <h3 class="manage-title">使用指南</h3>
        <div class="white-bg shadow margin-top-20 padding30 radius">
            <div class="use-box">
                <h3>一、达人认证注册</h3>
                <p>个人用户选择达人角色进行认证申请，线上填写资料和预约培训时间，线下进行资料审核及基础培训。完成资料审核及培训即可通过达人认证，成为{{this.$store.state.siteName}}平台的达人用户，就可以在任务大厅抢单。</p>
                <h3>二、关于赏金</h3>
                <p>1、什么是赏金</p>
                <p class="sj">赏金即达人完成订单任务并达标后获得的佣金。</p>
                <p>2.如何获得赏金</p>
                <p class="sj">(1) 在任务规定时间内完成任务并且达标则可获得对应的赏金；</p>
                <p class="sj">(2) 推荐企业/达人进驻亦可获得对应的赏金福利。</p>
                <p>3.赏金如何提现？</p>
                <p class="sj">(1) 达人赏金可直接提现至微信零钱（网站暂时没开放提现功能，可以在{{this.$store.state.siteName}}小程序中进行提现操作），提现实时到账；</p>
                <p class="sj">(2) 余额满20元可发起提现，单日提现次数不得超过10次，单日最高提现金额5000元。</p>
                <p class="img"><img src="@/assets/images/darenzhinan.png"></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EnterpriseUse'
}
</script>
